import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Image from '../../elements/Image';

// The KEEP ME OUT wordmark (white letters, gradient keyhole). A <div>, not an <h1>: each route owns
// its single <h1>. The footer passes className="mk-logo--sm" (rendered at 59×32 via CSS).
const Logo = ({ className, ...props }) => {
  const classes = classNames('brand', className);

  return (
    <div {...props} className={classes}>
      <div className='m-0 mk-logo'>
        <Link to='/'>
          <Image
            src={require('./../../../assets/images/logo-black.svg').default}
            alt='Keep Me Out home'
            width={74}
            height={40}
          />
        </Link>
      </div>
    </div>
  );
};

export default Logo;
